import { useTanks } from '@api/useTanks'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { ErrorNotification, NotificationMessage } from '@gravitate-js/excalibrr'
import { Form } from 'antd'
import React, { useEffect, useState } from 'react'

import { StoreInfoRows } from './StoreInfoRows'
import { StoreNumberTankIdStatusRow } from './StoreNumberTankIdStatusRow'
import { TankDescriptionRow } from './TankDescriptionRow'
import { useMetadata } from '@api/useMetadata'

export function TankInfo({ tank, loading, setLoading }) {
  const { scopes } = useSecurityContext()
  const [editing, setEditing] = useState(false)
  const [form] = Form.useForm()
  const canEditStores = scopes.admin?.site_write
  const canEditHolds = scopes.admin?.tank_compliance_hold_write
  const { deleteTankMutation, updateTankMutation } = useTanks()
  const { mutateAsync: updateMutate } = updateTankMutation()
  const { mutateAsync: deleteMutate } = deleteTankMutation()
  const { data: metadata } = useMetadata('store/tank')

  useEffect(() => {
    form.setFieldsValue({ ...tank })
  }, [tank])

  const handleSave = (formData) => {
    setLoading(true)

    if (formData.carrier_id) {
      formData.carrier = metadata.carriers.find((carrier) => carrier.id === formData.carrier_id)?.name
    } else {
      formData.carrier = null
      formData.carrier_id = null
    }

    const updatedTank = {
      ...tank,
      ...formData,
      id: undefined,
      backup_id: tank.id,
    }
    updateMutate(updatedTank)
      .then(() => {
        NotificationMessage('Tank Info Updated', 'Tank info has been successfully updated', false)
        setLoading(false)
        setEditing(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }
  const handleDelete = async () => {
    setLoading(true)
    const deleteTank = { store_id: tank.store_id, tank_id: tank.tank_id }
    deleteMutate(deleteTank)
      .then(() => {
        setEditing(false)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <div className='store-expand-card p-4'>
      <Form
        form={form}
        className='store-info-form'
        size='small'
        onFinish={handleSave}
        onFinishFailed={(msg) => {
          ErrorNotification(msg)
          setLoading(false)
        }}
      >
        <TankDescriptionRow
          tank={tank}
          canEditStores={canEditStores}
          editing={editing}
          setEditing={setEditing}
          loading={loading}
          handleDelete={handleDelete}
          form={form}
          canEditHolds={canEditHolds}
        />
        <StoreNumberTankIdStatusRow tank={tank} editing={editing} />
        <StoreInfoRows form={form} metadata={metadata} tank={tank} editing={editing} />
      </Form>
    </div>
  )
}
